import { awmFundsDataSelectorConfig } from './awmFundsData'
import { productOperationDetailSelectorConfig } from './operationDetail'

export const selectorsConfig = {
  ...awmFundsDataSelectorConfig,
  ...productOperationDetailSelectorConfig,
}
